// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block-content[data-v-2ff49194] >:last-child{margin-bottom:0}.block-content[data-v-2ff49194]  img{max-width:100%}.block-content[data-v-2ff49194]  a[href]{font-weight:500;-webkit-text-decoration:underline;text-decoration:underline}.block-content[data-v-2ff49194]  a[href]:focus,.block-content[data-v-2ff49194]  a[href]:hover{-webkit-text-decoration:none;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
